export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10598.9d8addae.jpg";